import styled from "@emotion/styled"

export const StyledUl = styled.ul`
  list-style-type: none;
  display: flex;
  gap: 20px;
`

export const StyledLi = styled.li`
  &:hover {
    .css-15lzvfn {
      width: 70px;
      height: 70px;
      transition: 0.15s ease;
    }
  }
  .isActive {
    .css-7rozcl{
      background-color:var(--chakra-colors-primary);
      svg {
        fill: white;
      }
    }
    .outlined-text {
      opacity: 1;
      visibility: visible;
    }
    .css-15lzvfn {
      background: var(--chakra-colors-primary);
      width: 70px;
      height: 70px;
      transition: 0.3s ease;
      svg {
        fill: white;
      }
    }
  }
`
